window.addEventListener("load", function(event) {

    if (document.getElementById('mc_embed_signup') != null) {
        const params = new URLSearchParams(window.location.search);
        document.getElementById('mce-MMERGE7').value = params.get('utm_source') || '';
        document.getElementById('mce-MMERGE8').value = params.get('utm_medium') || '';
        document.getElementById('mce-MMERGE9').value = params.get('utm_campaign') || '';
        document.getElementById('mce-MMERGE10').value = params.get('utm_content') || '';
    }

    const subscribeForm = document.getElementById('mc-embedded-subscribe-form');
    if (subscribeForm != null) {
       subscribeForm.addEventListener("submit", async (e) => { 
        e.preventDefault();
        document.getElementById('mce-success-response').style.display = 'none';
        document.getElementById('mce-error-response').style.display = 'none';
        try {
            console.log(JSON.stringify({
                    'FNAME': document.getElementById('mce-FNAME').value,
                    'EMAIL': document.getElementById('mce-EMAIL').value,
                    'MMERGE7': document.getElementById('mce-MMERGE7').value,
                    'MMERGE8': document.getElementById('mce-MMERGE8').value,
                    'MMERGE9': document.getElementById('mce-MMERGE9').value,
                    'MMERGE10': document.getElementById('mce-MMERGE10').value
                }));
            const response = await fetch('https://subscribe.scentxpresso.com/subscribe', {
                method: 'POST',
                mode: 'cors',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    'FNAME': document.getElementById('mce-FNAME').value,
                    'EMAIL': document.getElementById('mce-EMAIL').value,
                    'MMERGE7': document.getElementById('mce-MMERGE7').value,
                    'MMERGE8': document.getElementById('mce-MMERGE8').value,
                    'MMERGE9': document.getElementById('mce-MMERGE9').value,
                    'MMERGE10': document.getElementById('mce-MMERGE10').value
                })
            });
            const result = await response.json();
            if (result.success) {
                document.getElementById('mce-success-response').style.display = 'inline-block';
                document.getElementById('mce-success-response').innerHTML = result.status.replace(/(?:\r\n|\r|\n)/g, "<br>");
            } else {
                document.getElementById('mce-error-response').style.display = 'inline-block';
                document.getElementById('mce-error-response').innerText = result.error;
            }
        } catch (err) {
            alert(err);
            console.log(err);
            document.getElementById('mce-error-response').style.display = 'inline-block';
            document.getElementById('mce-error-response').innerText = 'Subscription failed.';
        }
       })
    }

});